// import { mapDashboardData } from "src/store/dashboard.store";
import { chartTypeConfig, chartThemeConfig } from "src/components/chart/chart.const";

//const { categoryAxis, seriesData, seriesName } = mapDashboardData;

export const widgetLayoutFormation = ({ podDetailList, itemConfig }) => {
  const items = [];
  podDetailList?.forEach((podDetail, index) => {
    items.push(itemConfig(podDetail, index));
  });
  return {
    items,
  };
};

export const formatNumber = (event) => {
  let formattedNumber = event?.value?.toFixed(2) || 0;
  if (formattedNumber.endsWith(".00")) {
    formattedNumber = formattedNumber.slice(0, -3);
  }
  formattedNumber = parseFloat(formattedNumber).toLocaleString();
  return formattedNumber;
};

export const shortenLargeNumber = (num, digits) => {
  var units = ["k", "M", "G", "T", "P", "E", "Z", "Y"],
    decimal;
  for (var i = units.length - 1; i >= 0; i--) {
    decimal = Math.pow(1000, i + 1);
    if (num <= -decimal || num >= decimal) {
      return +(num / decimal).toFixed(digits) + units[i];
    }
  }
  return num;
};

export const shortLabel = (event) => {
  if (event?.value) {
    return shortenLargeNumber(event?.value, 2);
  }
  if (event.value.length > 15) {
    const value = event.value.substring(0, 15);
    return `${value}...`;
  }
  return event?.value || "";
};

export const generateCategoryChartData = (resultData, datasetData, tabThemeColors, colorIdx) => {
  const datasetResultData = resultData.filter((o) => o.dataset_index === datasetData.dashboard_dataset_num);
  const uniqueSeries = [...new Set(datasetResultData.map((item) => item.series_name))];
  const uniqueCategories = [...new Set(resultData.map((item) => item.category_axis))];
  const categoryIndexMap = new Map(uniqueCategories.map((category, index) => [category, index]));
  const safeThemeColors = tabThemeColors?.length ? tabThemeColors : ["#0069A5"];
  const nextSeries = {};

  uniqueSeries.forEach((series, seriesIdx) => {
    const color = safeThemeColors[(colorIdx + seriesIdx) % safeThemeColors.length];
    nextSeries[series] = {
      name: series,
      visible: true,
      color,
      data: new Array(uniqueCategories.length).fill(0),
    };
  });

  datasetResultData.forEach((item) => {
    const categoryIdx = categoryIndexMap.get(item.category_axis);
    const targetSeries = nextSeries[item.series_name];
    if (targetSeries && categoryIdx !== undefined) {
      targetSeries.data[categoryIdx] = item.series_data || 0;
    }
  });

  const updatedColorIdx = colorIdx + uniqueSeries.length;
  return { seriesObj: nextSeries, colorIdx: updatedColorIdx };
};

const appendColorToRoundChart = (data, tabThemeColors) => {
  let colorIdx = 0;
  const safeThemeColors = tabThemeColors?.length ? tabThemeColors : ["#0069A5"];

  const result = data.map((o, i) => {
    if (colorIdx + 1 > safeThemeColors?.length) {
      colorIdx = 0;
    }

    const updated = {
      ...o,
      visible: true,
      color: safeThemeColors[colorIdx],
      key: i,
    };

    colorIdx++;

    return updated;
  });

  return result;

  /*
    uniqueList.forEach((sourceEle) => {
        if (colorIdx + 1 > tabThemeColors?.length) {
            colorIdx = 0;
        }

        data = data.reduce((acc, obj) => {
            if (obj?.[targetEle] === sourceEle) {
                //clone the object and modify the property
                const modifiedObj = {
                    ...obj,
                    visible: true,
                    color: tabThemeColors[colorIdx],
                };
                acc.push(modifiedObj);
            } else {
                // No modification needed, push the original object
                acc.push(obj);
            }
            return acc;
        }, []);

        colorIdx++;
    });

    console.log("after data :: ", data);
    return data;
    */
};

export const dataParser = ({ data, dataSetData, chartTheme }) => {
  if (!Array.isArray(data) || data.length === 0) {
    return {
      categoryAxisList: [],
      chartData: [],
      chartBackgroundColor: "",
    };
  }

  let categoryAxisList = [];
  let chartData = [];

  const pieKey = chartTypeConfig.pie.key;
  const bubbleKey = chartTypeConfig.bubble.key;

  if (dataSetData?.[0]?.chart_type?.toLowerCase() === bubbleKey) {
    categoryAxisList = [...new Set(data.map((item) => item.category))];
  } else {
    categoryAxisList = [...new Set(data.map((item) => item.category_axis))];
  }

  const normalizedTheme = (chartTheme || "default").toLowerCase();
  const tabThemeConfig =
    chartThemeConfig.find((o) => o.value.toLocaleLowerCase() === normalizedTheme) ||
    chartThemeConfig.find((o) => o.value.toLocaleLowerCase() === "default");

  const tabThemeColors = tabThemeConfig?.color;
  const chartBackgroundColor = tabThemeConfig?.background || "";

  let colorIdx = 0;

  dataSetData?.forEach((dataSet) => {
    let seriesObjValues = [];
    const dataSetChartType = dataSet?.chart_type?.toLowerCase();

    if ([pieKey, bubbleKey].includes(dataSetChartType)) {
      seriesObjValues = appendColorToRoundChart(data, tabThemeColors);
    } else {
      const seriesData = generateCategoryChartData(data, dataSet, tabThemeColors, colorIdx);

      const seriesObj = seriesData?.seriesObj;
      colorIdx = seriesData?.colorIdx;

      if (seriesObj && Object.values(seriesObj)?.length) {
        seriesObjValues = Object.values(seriesObj);
      }
    }

    chartData = [
      ...chartData,
      {
        data: seriesObjValues,
        isStacked: dataSet?.is_stacked,
        chartType: dataSetChartType,
      },
    ];
  });

  return {
    categoryAxisList,
    chartData,
    chartBackgroundColor,
  };
};

const pickSampleIndexes = (size, maxPoints) => {
  if (size <= maxPoints) {
    return null;
  }

  const stride = Math.ceil(size / maxPoints);
  const indexes = [];

  for (let idx = 0; idx < size; idx += stride) {
    indexes.push(idx);
  }

  if (indexes[indexes.length - 1] !== size - 1) {
    indexes.push(size - 1);
  }

  return indexes;
};

export const optimizeChartPayload = ({
  categoryAxisList = [],
  chartData = [],
  maxCategoryPoints = 350,
  maxRoundPoints = 250,
}) => {
  const sampledCategoryIndexes = pickSampleIndexes(categoryAxisList.length, maxCategoryPoints);
  const sampledCategories = sampledCategoryIndexes
    ? sampledCategoryIndexes.map((idx) => categoryAxisList[idx])
    : categoryAxisList;

  const optimizedChartData = chartData.map((chartItem) => {
    if (["pie", "bubble"].includes(chartItem?.chartType)) {
      return {
        ...chartItem,
        data: Array.isArray(chartItem?.data) ? chartItem.data.slice(0, maxRoundPoints) : [],
      };
    }

    if (!sampledCategoryIndexes) {
      return chartItem;
    }

    const sampledSeries = (chartItem?.data || []).map((seriesItem) => ({
      ...seriesItem,
      data: sampledCategoryIndexes.map((sampleIdx) => seriesItem?.data?.[sampleIdx] || 0),
    }));

    return {
      ...chartItem,
      data: sampledSeries,
    };
  });

  return {
    categoryAxisList: sampledCategories,
    chartData: optimizedChartData,
    isSampled: Boolean(sampledCategoryIndexes),
  };
};
